import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { DELETE_CANDIDATE_SPECIAL_CONSIDERATION_LISTING_URL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useDeleteCandidateListing = ({ onSuccess, onError }: Input) => {
  const deleteCandidateListing = async (uuid: string) => {
    await axiosClient.delete(DELETE_CANDIDATE_SPECIAL_CONSIDERATION_LISTING_URL(uuid));
  };

  return useCustomMutation(deleteCandidateListing, {
    onSuccess,
    onError,
  });
};
